import { useState } from 'react';
import {
    TextField,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Button,
    FormHelperText,
    CircularProgress,
    Grid,
    Box,
    Checkbox,
} from '@mui/material';


// Relative Imports
import './LandingPage.css';
import C from '../../Constants/Constants';


const ContentBodySignUp = (props) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [passwordConfirm, setPasswordConfirm] = useState('');
    const [errors, setErrors] = useState({});

    const [firstName, setFirstName] = useState(props.cognitoAttributes.given_name === undefined ? '' : props.cognitoAttributes.given_name);
    const [lastName, setLastName] = useState(props.cognitoAttributes.family_name === undefined ? '' : props.cognitoAttributes.family_name);
    const [teamName, setTeamName] = useState(props.cognitoAttributes['custom:teamName'] === undefined ? '' : props.cognitoAttributes['custom:teamName']);
    const [teamAbbrev, setTeamAbbrev] = useState(props.cognitoAttributes['custom:teamAbbrev'] === undefined ? '' : props.cognitoAttributes['custom:teamAbbrev']);
    const [compLevel, setCompLevel] = useState(props.cognitoAttributes['custom:compLevel'] === undefined ? '' : props.cognitoAttributes['custom:compLevel']);
    
    const [isTermsChecked, setIsTermsChecked] = useState(false);

    function handlerOnChangeTextInput(event, target) {
        const thisElement = event.target;
        if (target === 'email') setEmail(thisElement.value);
        if (target === 'password') setPassword(thisElement.value);
        if (target === 'passwordConfirm') setPasswordConfirm(thisElement.value);
        if (target === 'firstName') setFirstName(thisElement.value);
        if (target === 'lastName') setLastName(thisElement.value);
        if (target === 'teamName') setTeamName(thisElement.value);
        if (target === 'teamAbbrev') setTeamAbbrev(thisElement.value);
        if (target === 'compLevel') setCompLevel(thisElement.value);
    }

    function handlerOnSubmit() {

        const errors = {};

        const trimmedEmail = email.trim();
        const trimmedPassword = password; // DO NOT TRIM
        const trimmedConfirmPassword = passwordConfirm; // DO NOT TRIM
        const trimmedFirstName = firstName.trim();
        const trimmedLastName = lastName.trim();
        const trimmedTeamName = teamName.trim();
        const trimmedTeamAbbrev = teamAbbrev.trim();
        const trimmedCompLevel = compLevel.trim();


        // Copy how lambda uses PROFILE_COMPLETION
        // This makes it easier to update if needed in the future
        const TP = {};
        TP.V = props.config.validations;

        let result;

        // email
        setEmail(trimmedEmail);
        result = validateEntry(trimmedEmail, TP.V.SIGN_UP.EMAIL, TP.V.RULE_TYPE);
        if (!result.result) {
            errors.email = result.message[0];
        }

        // password
        setPassword(trimmedPassword);
        result = validateEntry(trimmedPassword, TP.V.SIGN_UP.PASSWORD, TP.V.RULE_TYPE);
        if (!result.result) {
            errors.password = result.message[0];
        }

        // confirmPassword
        if (trimmedPassword !== trimmedConfirmPassword) {
            errors.passwordConfirm = 'Passwords do not match.';
        }        

        // firstName
        setFirstName(trimmedFirstName);
        result = validateEntry(trimmedFirstName, TP.V.PROFILE_COMPLETION.FIRST_NAME, TP.V.RULE_TYPE);
        if (!result.result) {
            errors.firstName = result.message[0];
        }

        // lastName
        setLastName(trimmedLastName);
        result = validateEntry(trimmedLastName, TP.V.PROFILE_COMPLETION.LAST_NAME, TP.V.RULE_TYPE);
        if (!result.result) {
            errors.lastName = result.message[0];
        }

        // teamName
        setTeamName(trimmedTeamName);
        result = validateEntry(trimmedTeamName, TP.V.PROFILE_COMPLETION.TEAM_NAME, TP.V.RULE_TYPE);
        if (!result.result) {
            errors.teamName = result.message[0];
        }

        // teamAbbrev
        setTeamAbbrev(trimmedTeamAbbrev);
        result = validateEntry(trimmedTeamAbbrev, TP.V.PROFILE_COMPLETION.TEAM_ABBREV, TP.V.RULE_TYPE);
        if (!result.result) {
            errors.teamAbbrev = result.message[0];
        }

        // compLevel
        setCompLevel(trimmedCompLevel);
        result = validateEntry(trimmedCompLevel, TP.V.PROFILE_COMPLETION.COMPETITION_LEVEL, TP.V.RULE_TYPE);
        if (!result.result) {
            errors.compLevel = result.message[0];
        }

        // isTermsChecked
        if (!isTermsChecked) {
            errors.isTermsChecked = 'You must accept the Terms of Service and Privacy Policy.';
        }

        console.log({errors});
        setErrors(errors);

        if (Object.keys(errors).length > 0) return;

        // props.handlerOnSubmitProfileUpdate({
        //     firstName: trimmedFirstName,
        //     lastName: trimmedLastName,
        //     teamName: trimmedTeamName,
        //     teamAbbrev: trimmedTeamAbbrev,
        //     compLevel: trimmedCompLevel,
        // });

        // Submit Sign Up
        props.handlerOnSubmitSignUp({
            email: trimmedEmail,
            password: trimmedPassword,
            firstName: trimmedFirstName,
            lastName: trimmedLastName,
            teamName: trimmedTeamName,
            teamAbbrev: trimmedTeamAbbrev,
            compLevel: trimmedCompLevel,
        });
    }

    // function handlerOnClickSubmit() {

    //     props.setIsCommunicating(true);

    //     const errors = {};

        

    //     // Copy how lambda uses PROFILE_COMPLETION
    //     // This makes it easier to update if needed in the future
    //     const TP = {};
    //     TP.V = props.config.validations;

    //     let result;

        

    //     console.log({errors});
    //     setErrors(errors);

    //     if (Object.keys(errors).length > 0) {
    //         props.setIsCommunicating(false);
    //         return;
    //     }

    //     // Submit Sign Up
    //     // props.handlerOnSubmitSignUp({
    //     //     email: trimmedEmail,
    //     //     password: trimmedPassword,
    //     // });

    // }

    function handlerOnClickCancel() {
        props.setUserState(C.USER_STATE.LOGGED_OUT);
    }

    return (
        <div className="contentBodyWrapper" id="ContentBodySignUpWrapper">
            <div className="contentBody" id="ContentBodySignUp">

                <h3>CREATE AN ACCOUNT</h3>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>

                        <TextField fullWidth type='email' id="TextFieldEmail" label="Email" variant="outlined" value={email} onChange={(e) => handlerOnChangeTextInput(e, 'email')} error={errors.email !== undefined} helperText={errors.email} />
                        <TextField fullWidth type='password' id="TextFieldPassword" label="Password" variant="outlined" value={password} onChange={(e) => handlerOnChangeTextInput(e, 'password')} error={errors.password !== undefined} helperText={errors.password} />
                        <TextField fullWidth type='password' id="TextFieldPasswordConfirm" label="Confirm Password" variant="outlined" value={passwordConfirm} onChange={(e) => handlerOnChangeTextInput(e, 'passwordConfirm')} error={errors.passwordConfirm !== undefined} helperText={errors.passwordConfirm} />
                        <FormControl variant='outlined' fullWidth className="SelectFieldFormControl">
                            <InputLabel>Competition Level</InputLabel>
                            <Select label="Competition Level" placeholder='Competition Level' labelId='SelectFieldCompLevelLabel' className="selectField" id="SelectFieldCompLevel"  value={compLevel} onChange={(e) => handlerOnChangeTextInput(e, 'compLevel')} >
                                <MenuItem className="chooseOne" value="">Choose One</MenuItem>
                                <MenuItem value="HIGH_SCHOOL">High School</MenuItem>
                                <MenuItem value="NCAA">NCAA</MenuItem>
                                <MenuItem value="NFL">NFL</MenuItem>
                            </Select>
                            {errors.compLevel !== undefined ? <FormHelperText>{errors.compLevel}</FormHelperText> : null}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth className='textField' id="TextFieldFirstName" label="First Name" variant="outlined" value={firstName} onChange={(e) => handlerOnChangeTextInput(e, 'firstName')} error={errors.firstName !== undefined} helperText={errors.firstName} placeholder='e.g. John' />
                        <TextField fullWidth className='textField' id="TextFieldLastName" label="Last Name" variant="outlined" value={lastName} onChange={(e) => handlerOnChangeTextInput(e, 'lastName')} error={errors.lastName !== undefined} helperText={errors.lastName} placeholder='e.g. Smith' />
                        <TextField fullWidth className='textField' id="TextFieldTeamName" label="Team Name" variant="outlined" value={teamName} onChange={(e) => handlerOnChangeTextInput(e, 'teamName')} error={errors.teamName !== undefined} helperText={errors.teamName} placeholder='e.g. Oregon State University' />
                        <TextField fullWidth className='textField' id="TextFieldTeamAbbrev" label="Team Abbreviation" variant="outlined" value={teamAbbrev} onChange={(e) => handlerOnChangeTextInput(e, 'teamAbbrev')} error={errors.teamAbbrev !== undefined} helperText={errors.teamAbbrev} placeholder='e.g. OSU' />
                    </Grid>
                </Grid>
                <p className="isTermsCheckedError">{
                    errors.isTermsChecked !== undefined
                    ? errors.isTermsChecked
                    : ''
                }</p>
                <p>
                    <Checkbox
                        checked={isTermsChecked} onClick={ ()=> {
                            const newIsTermsChecked = !isTermsChecked;
                            setIsTermsChecked(newIsTermsChecked);
                        }}
                    /> I accept the 2 Minute Warning <a
                        target="_blank"
                        href="https://www.2minutewarning.com/terms-of-service" rel="noreferrer">Terms of Service</a><br />
                        and acknowledge the <a
                        target="_blank"
                        href="https://www.2minutewarning.com/privacy-policy" rel="noreferrer">Privacy Policy</a>.
                </p>
                <Box className="SubmitSignupAndCancelButtons">
                    <Button fullWidth variant="contained" className="button" id="ButtonSubmit" onClick={handlerOnSubmit} disabled={props.isCommunicating}>{props.isCommunicating ? <CircularProgress /> : 'SUBMIT'}</Button>
                    { Object.keys(errors).length > 0 ? <FormHelperText className='overallHelperText'>There are one or more errors on your submission. Please correct and resubmit.</FormHelperText> : null}
                    
                    {
                        // Check if url has a query string of signup=true
                        // If so, hide the cancel button
                        props.isSignup
                            ? null
                            : <Button className="blue" fullWidth onClick={handlerOnClickCancel} disabled={props.isCommunicating}>CANCEL</Button>
                    }
                </Box>
                
                {/* <Button fullWidth onClick={handlerOnClickSubmit} disabled={props.isCommunicating}>{props.isCommunicating ? <CircularProgress /> : 'SUBMIT'}</Button> */}
                
            </div>
        </div>
    )
}
                


const ContentBodyLoggedOut = (props) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errors, setErrors] = useState({});

    function handlerOnChangeTextInput(event, target) {
        const thisElement = event.target;
        if (target === 'email') setEmail(thisElement.value);
        if (target === 'password') setPassword(thisElement.value);
    }

    function handlerOnClickCreateAccount() {
        props.setUserState(C.USER_STATE.SIGN_UP);
    }

    function handlerOnClickSubmitLogin() {
            
        props.setIsCommunicating(true);

        const errors = {};

        const trimmedEmail = email.trim();
        const trimmedPassword = password; // DO NOT TRIM

        // Copy how lambda uses PROFILE_COMPLETION
        // This makes it easier to update if needed in the future
        const TP = {};
        TP.V = props.config.validations;

        let result;

        // email
        setEmail(trimmedEmail);
        result = validateEntry(trimmedEmail, TP.V.SIGN_UP.EMAIL, TP.V.RULE_TYPE);
        if (!result.result) {
            errors.email = result.message[0];
        }

        // password
        setPassword(trimmedPassword);
        result = validateEntry(trimmedPassword, TP.V.SIGN_UP.PASSWORD, TP.V.RULE_TYPE);
        if (!result.result) {
            errors.password = result.message[0];
        }

        console.log({errors});
        setErrors(errors);

        if (Object.keys(errors).length > 0) {
            props.setIsCommunicating(false);
            return;
        }

        // Submit Sign Up
        props.handlerOnSubmitLogin(trimmedEmail, trimmedPassword);

    }

    function handlerOnClickForgotPassword() {
        props.setUserState(C.USER_STATE.RESET_PASSWORD);
    }

    return (
        <div className="contentBodyWrapper" id="ContentBodyLoggedOutWrapper">
            <div className="contentBody" id="ContentBodyLoggedOut">
                <h3>LOGIN TO 2MW</h3>
                <TextField type="email" fullWidth id="TextFieldEmail" label="Email" variant="outlined" value={email} onChange={(e) => handlerOnChangeTextInput(e, 'email')} error={errors.email !== undefined} helperText={errors.email} />
                <TextField type="password" fullWidth id="TextFieldPassword" label="Password" variant="outlined" value={password} onChange={(e) => handlerOnChangeTextInput(e, 'password')} error={errors.password !== undefined} helperText={errors.password} />
                <Button disabled={props.isCommunicating} fullWidth onClick={handlerOnClickSubmitLogin}>{ props.isCommunicating ? <CircularProgress /> : 'LOGIN' }</Button>
                {/* <Button id="forgotPassword" onClick={handlerOnClickForgotPassword} >Forgot Password?</Button> */}
                <p className="noAccount">Don't have an account?</p>
                <Button className='blue' fullWidth onClick={handlerOnClickCreateAccount}  disabled={props.isCommunicating}>CREATE AN ACCOUNT</Button>
            </div>
        </div>
    )        
}

const ContentBodyUnconfirmed = (props) => {
    return (<div className="contentBody" id="ContentBodyUnconfirmed">
        <h3>Account Unconfirmed</h3>
        <p>To access 2 Minute Warning AI services, you will need to verify your email.</p>
        <p><a href="https://ddamen.2minutewarning.com">Click here</a> to resend the verification email and follow the link provided. Kindly look into your spam/junk folders too.</p>
        <p>If you need assistance, please contact us at <a href="mailto:info@2minutewarning.com">info@2minutewarning.com</a>.</p>
    </div>)        
}

const ContentBodyIncomplete = (props) => {
    const [email, setEmail] = useState(props.cognitoAttributes.email === undefined ? '' : props.cognitoAttributes.email);
    const [errors, setErrors] = useState({});

    const [firstName, setFirstName] = useState(props.cognitoAttributes.given_name === undefined ? '' : props.cognitoAttributes.given_name);
    const [lastName, setLastName] = useState(props.cognitoAttributes.family_name === undefined ? '' : props.cognitoAttributes.family_name);
    const [teamName, setTeamName] = useState(props.cognitoAttributes['custom:teamName'] === undefined ? '' : props.cognitoAttributes['custom:teamName']);
    const [teamAbbrev, setTeamAbbrev] = useState(props.cognitoAttributes['custom:teamAbbrev'] === undefined ? '' : props.cognitoAttributes['custom:teamAbbrev']);
    const [compLevel, setCompLevel] = useState(props.cognitoAttributes['custom:compLevel'] === undefined ? '' : props.cognitoAttributes['custom:compLevel']);

    function handlerOnChangeTextInput(event, target) {
        const thisElement = event.target;
        if (target === 'email') setEmail(thisElement.value);
        if (target === 'firstName') setFirstName(thisElement.value);
        if (target === 'lastName') setLastName(thisElement.value);
        if (target === 'teamName') setTeamName(thisElement.value);
        if (target === 'teamAbbrev') setTeamAbbrev(thisElement.value);
        if (target === 'compLevel') setCompLevel(thisElement.value);
    }

    function handlerOnSubmit() {

        const errors = {};

        const trimmedFirstName = firstName.trim();
        const trimmedLastName = lastName.trim();
        const trimmedTeamName = teamName.trim();
        const trimmedTeamAbbrev = teamAbbrev.trim();
        const trimmedCompLevel = compLevel.trim();


        // Copy how lambda uses PROFILE_COMPLETION
        // This makes it easier to update if needed in the future
        const TP = {};
        TP.V = props.config.validations;

        let result;

        // firstName
        setFirstName(trimmedFirstName);
        result = validateEntry(trimmedFirstName, TP.V.PROFILE_COMPLETION.FIRST_NAME, TP.V.RULE_TYPE);
        if (!result.result) {
            errors.firstName = result.message[0];
        }

        // lastName
        setLastName(trimmedLastName);
        result = validateEntry(trimmedLastName, TP.V.PROFILE_COMPLETION.LAST_NAME, TP.V.RULE_TYPE);
        if (!result.result) {
            errors.lastName = result.message[0];
        }

        // teamName
        setTeamName(trimmedTeamName);
        result = validateEntry(trimmedTeamName, TP.V.PROFILE_COMPLETION.TEAM_NAME, TP.V.RULE_TYPE);
        if (!result.result) {
            errors.teamName = result.message[0];
        }

        // teamAbbrev
        setTeamAbbrev(trimmedTeamAbbrev);
        result = validateEntry(trimmedTeamAbbrev, TP.V.PROFILE_COMPLETION.TEAM_ABBREV, TP.V.RULE_TYPE);
        if (!result.result) {
            errors.teamAbbrev = result.message[0];
        }

        // compLevel
        setCompLevel(trimmedCompLevel);
        result = validateEntry(trimmedCompLevel, TP.V.PROFILE_COMPLETION.COMPETITION_LEVEL, TP.V.RULE_TYPE);
        if (!result.result) {
            errors.compLevel = result.message[0];
        }

        console.log({errors});
        setErrors(errors);

        if (Object.keys(errors).length > 0) return;

        props.handlerOnSubmitProfileUpdate({
            firstName: trimmedFirstName,
            lastName: trimmedLastName,
            teamName: trimmedTeamName,
            teamAbbrev: trimmedTeamAbbrev,
            compLevel: trimmedCompLevel,
        });
    }

    return (
        <div className="contentBodyWrapper" id="ContentBodyLoggedOutWrapper">
        
            <div className="contentBody" id="ContentBodyIncomplete">
            <h3>Almost there!</h3>
            <p>Please complete your profile to access our breakdown service.</p>
            <p>Get { props.config?.freeCreditsOnProfileCompletion === undefined ? '-' : props.config.freeCreditsOnProfileCompletion } free plays analyzed after completing your profile!</p>
            

            <div className="FormContainer">
                <TextField fullWidth className='textField' id="TextFieldEmail" label="Email" variant="outlined" value={email} onChange={(e) => handlerOnChangeTextInput(e, 'email')} error={errors.email !== undefined} helperText={errors.email} disabled/>
                <TextField fullWidth className='textField' id="TextFieldFirstName" label="First Name" variant="outlined" value={firstName} onChange={(e) => handlerOnChangeTextInput(e, 'firstName')} error={errors.firstName !== undefined} helperText={errors.firstName} placeholder='e.g. John' />
                <TextField fullWidth className='textField' id="TextFieldLastName" label="Last Name" variant="outlined" value={lastName} onChange={(e) => handlerOnChangeTextInput(e, 'lastName')} error={errors.lastName !== undefined} helperText={errors.lastName} placeholder='e.g. Smith' />
                <TextField fullWidth className='textField' id="TextFieldTeamName" label="Team Name" variant="outlined" value={teamName} onChange={(e) => handlerOnChangeTextInput(e, 'teamName')} error={errors.teamName !== undefined} helperText={errors.teamName} placeholder='e.g. Oregon State University' />
                <TextField fullWidth className='textField' id="TextFieldTeamAbbrev" label="Team Abbreviation" variant="outlined" value={teamAbbrev} onChange={(e) => handlerOnChangeTextInput(e, 'teamAbbrev')} error={errors.teamAbbrev !== undefined} helperText={errors.teamAbbrev} placeholder='e.g. OSU' />
                
                <FormControl variant='outlined' fullWidth className="SelectFieldFormControl">
                    <InputLabel>Competition Level</InputLabel>
                    <Select label="Competition Level" placeholder='Competition Level' labelId='SelectFieldCompLevelLabel' className="selectField" id="SelectFieldCompLevel"  value={compLevel} onChange={(e) => handlerOnChangeTextInput(e, 'compLevel')} >
                        <MenuItem className="chooseOne" value="">Choose One</MenuItem>
                        <MenuItem value="HIGH_SCHOOL">High School</MenuItem>
                        <MenuItem value="NCAA">NCAA</MenuItem>
                        <MenuItem value="NFL">NFL</MenuItem>
                    </Select>
                    {errors.compLevel !== undefined ? <FormHelperText>{errors.compLevel}</FormHelperText> : null}
                </FormControl>

                <Button fullWidth variant="contained" className="button" id="ButtonSubmit" onClick={handlerOnSubmit} disabled={props.isCommunicating}>{props.isCommunicating ? <CircularProgress /> : 'COMPLETE MY PROFILE'}</Button>
                { Object.keys(errors).length > 0 ? <FormHelperText className='overallHelperText'>There are one or more errors on your submission. Please correct and resubmit.</FormHelperText> : null}

            </div>
        </div>

    </div>)        
}

const ContentBodyForgotPassword = (props) => {
    const [email, setEmail] = useState('');
    const [errors, setErrors] = useState({});

    function handlerOnChangeTextInput(event, target) {
        const thisElement = event.target;
        if (target === 'email') setEmail(thisElement.value);
    }

    function handlerOnClickSubmit() {
        const errors = {};

        // Copy how lambda uses PROFILE_COMPLETION
        // This makes it easier to update if needed in the future
        const TP = {};
        TP.V = props.config.validations;

        let result;

        // email
        result = validateEntry(email, TP.V.FORGOT_PASSWORD.EMAIL, TP.V.RULE_TYPE);
        if (!result.result) {
            errors.email = result.message[0];
        }

        setErrors(errors);

        if (Object.keys(errors).length > 0) return;

        props.handlerOnSubmitResetPassword({
            email: email,
        });

    }
    
    function handlerOnClickCancel() {
        props.setUserState(C.USER_STATE.LOGGED_OUT)
    }

    return (
        <div className="contentBodyWrapper" id="ContentBodyForgotPasswordWrapper">
            <div className="contentBody" id="ContentBodyForgotPassword">
                <h3>FORGOT PASSWORD</h3>
                <TextField type="email" fullWidth id="TextFieldEmailForgotPass" label="Email" variant="outlined" value={email} onChange={(e) => handlerOnChangeTextInput(e, 'email')} error={errors.email !== undefined} helperText={errors.email} />
                <Button className='blue' fullWidth onClick={handlerOnClickSubmit}  disabled={props.isCommunicating}>SUBMIT</Button>
                <Button className='orange' fullWidth onClick={handlerOnClickCancel}  disabled={props.isCommunicating}>CANCEL</Button>
            </div>
        </div>
    );
};

const ContentBodyResetPassword = (props) => {
    const [newPass, setNewPass] = useState('');
    const [confirmNewPass, setConfirmNewPass] = useState('');
    const [errors, setErrors] = useState({});

    function handlerOnChangeTextInput(event, target) {
        const thisElement = event.target;
        if (target === 'newPass') setNewPass(thisElement.value);
        if (target === 'confirmNewPass') setConfirmNewPass(thisElement.value);
    }

    function handlerOnClickSubmit() {
        const errors = {};

        // Copy how lambda uses PROFILE_COMPLETION
        // This makes it easier to update if needed in the future
        const TP = {};
        TP.V = props.config.validations;

        let result;

        // newPass
        result = validateEntry(newPass, TP.V.RESET_PASSWORD.NEW_PASSWORD, TP.V.RULE_TYPE);
        if (!result.result) {
            errors.newPass = result.message[0];
        }

        // confirmNewPass
        result = validateEntry(confirmNewPass, TP.V.RESET_PASSWORD.NEW_PASSWORD, TP.V.RULE_TYPE);
        if (!result.result) {
            errors.confirmNewPass = result.message[0];
        }

        if (newPass !== confirmNewPass) {
            errors.confirmNewPass = 'Passwords do not match';
        }

        // Get all url query params
        const urlParams = new URLSearchParams(window.location.search);
    
        // Check if reset_token is set
        if (!urlParams.has('reset_token')) {
            errors.overall = 'Reset token is not set.';
        }

        // Check if email is set
        if (!urlParams.has('email')) {
            errors.overall = 'Email is not set.';
        }

        setErrors(errors);

        if (Object.keys(errors).length > 0) return;

        props.handlerOnSubmitResetPassword({
            email: urlParams.get('email'),
            resetToken: urlParams.get('reset_token'),
            newPassword: newPass,
        });

    }

    function handlerOnClickCancel() {
        props.setUserState(C.USER_STATE.LOGGED_OUT)
    }

    return (
        <div className="contentBodyWrapper" id="ContentBodyResetPasswordWrapper">
            <div className="contentBody" id="ContentBodyResetPassword">
                <h3>RESET PASSWORD</h3>
                <TextField
                    fullWidth
                    type="password"
                    id="TextFieldNewPassword"
                    label="Type a New Password"
                    variant="outlined"
                    value={newPass}
                    onChange={(e) => handlerOnChangeTextInput(e, 'newPass')}
                    error={errors.newPass !== undefined}
                    helperText={errors.newPass}
                />
                <TextField
                    fullWidth
                    type="password"
                    id="TextFieldConfirmNewPassword"
                    label="Confirm New Password"
                    variant="outlined"
                    value={confirmNewPass}
                    onChange={(e) => handlerOnChangeTextInput(e, 'confirmNewPass')}
                    error={errors.confirmNewPass !== undefined}
                    helperText={errors.confirmNewPass}
                />
                <FormHelperText
                    className="overallHelperText"
                    id="FormHelperTextResetPassword"
                >
                    {errors.overall !== undefined ? errors.overall : null}
                </FormHelperText>
                <Button className='blue' fullWidth onClick={handlerOnClickSubmit}  disabled={props.isCommunicating}>SUBMIT</Button>
                <Button className='orange' fullWidth onClick={handlerOnClickCancel}  disabled={props.isCommunicating}>CANCEL</Button>
            </div>
        </div>
    );
};


const ContentBodyResetPasswordSuccess = (props) => {
    function handlerOnClickGoBack() {
        props.setUserState(C.USER_STATE.LOGGED_OUT)
    }

    function handlerOnClickGoToHudl() {
        window.location.href = 'https://www.hudl.com';
    }
    return (
        <div className="contentBodyWrapper" id="ContentBodyResetPasswordSuccessWrapper">
            <div className="contentBody" id="ContentBodyResetPasswordSuccess">
                <h3>SUCCESS!</h3>
                <p>Your password is successfully updated!</p>
                <Button className='blue' fullWidth onClick={handlerOnClickGoBack}  disabled={props.isCommunicating}>Go Back to Login</Button>
                <Button className='orange' fullWidth onClick={handlerOnClickGoToHudl}  disabled={props.isCommunicating}>Go to Hudl</Button>
            </div>
        </div>
    );
};


const ContentBody = (props) => {
    return (<div id="ContentBody">
        
        { props.userState === C.USER_STATE.UNCONFIRMED ? <ContentBodyUnconfirmed {...props}/> : null }
        { props.userState === C.USER_STATE.LOGGED_OUT ? <ContentBodyLoggedOut {...props}/> : null }
        { props.userState === C.USER_STATE.SIGN_UP ? <ContentBodySignUp {...props}/> : null }
        { props.userState === C.USER_STATE.INCOMPLETE ? <ContentBodyIncomplete {...props} /> : null }
        { props.userState === C.USER_STATE.RESET_PASSWORD ? <ContentBodyResetPassword {...props} /> : null }
        { props.userState === C.USER_STATE.RESET_PASSWORD_SUCCESS ? <ContentBodyResetPasswordSuccess {...props} /> : null }
        {/* { true ? <ContentBodyUnconfirmed /> : null } */}
        
    </div>);
}

const LandingPage = (props) => {
    return (<div className="page" id="LandingPage">
        {/* <h3 className='welcome'>{ props.firstname === undefined ? '' : 'Welcome ' + props.firstname + '!' }</h3> */}
        <ContentBody {...props} />
    </div>);
}


// Helper Methods

function validateEntry(entry, rule, ruleType) {
    let errorFound = false;
  
    // Currently, all fields are assumed required.
    // TODO: Add logic to check if field is required or not.
    // If it not, then skip validation if entry is undefined or empty.
    if (entry === undefined || entry === null) {
      errorFound = true;
      return {
        message: [`${rule.name} is required.`],
      };
    }
  
    // Variables
    const result = {
      message: [],
    };
    
    // Minimum Length
    if (ruleType.MIN_LENGTH in rule) {
      if (entry.length < rule[ruleType.MIN_LENGTH]) {
        errorFound = true;
        result.message.push(`${rule.name} must be at least ${rule[ruleType.MIN_LENGTH]} characters long.`);
      }
    }
  
    // Maximum Length
    if (ruleType.MAX_LENGTH in rule) {
      if (entry.length > rule[ruleType.MAX_LENGTH]) {
        errorFound = true;
        result.message.push(`${rule.name} must not exceed ${rule[ruleType.MAX_LENGTH]} characters long.`);
      }
    }
  
    // Regex
    if (ruleType.REGEX in rule) {
        const regexExpression = new RegExp(rule[ruleType.REGEX]);
        if (!regexExpression.test(entry)) {
          errorFound = true;
          result.message.push(rule[ruleType.REGEX_ERROR_MESSAGE]);
        }
    }
  
    // Enum
    if (ruleType.ENUM in rule) {
        if (!rule[ruleType.ENUM].map((item)=>item.value).includes(entry)) {
        errorFound = true;
        result.message.push(`${rule.name} must be one of the following: ${
            rule[ruleType.ENUM]
            .map((item)=>item.name)
            .join(', ')
        }.`);
        }
    }
    
    // Error Found
    if (errorFound) {
      result.result = false;
      return result;
    }
  
    // Error not found
    result.result = true;
    result.message.push('Entry has passed all validations.');
    return result;
}

export default LandingPage;